// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"map_iconSync__9LrJE","fa-spin":"map_fa-spin__p7eZi"};